import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  tokenId: string
  identityVerificationExternalId: string
}

export type FinishKycResponse = {
  status: string
  isOk: boolean
  errors: string[]
}

export function useFinishKyc() {
  const queryClient = useQueryClient()

  return useMutation<FinishKycResponse, unknown, MutationFnParams>({
    mutationFn: async ({ tokenId, identityVerificationExternalId }) => {
      const response = await fetcher(
        "/Verification/FinishKyc",
        {
          method: "PUT",
          body: JSON.stringify({
            tokenId,
            identityVerificationExternalId,
          }),
        },
        {
          useAccessToken: true,
        }
      )

      return response.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["VerificationStatus"] })
    },
  })
}
